<template>
  <div class="text-center">
    <v-dialog v-model="dialog" class="full-width" persistent>
      <v-card class="mc-card">
        <v-card-title class="mc-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="teal darken-3">mdi-check-circle-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Confirmar selección</div>
              <div class="text-body-2 white--text">
                Verifica los datos antes de guardar la oferta
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-card outlined class="pa-3 mb-3">
            <div class="text-subtitle-2 mb-1">Datos de la oferta</div>
            <div class="text-body-2 text--secondary">
              <b>Nombre:</b> {{ oferta.nombre_oferta }}
            </div>
            <div class="text-body-2 text--secondary">
              <b>Periodo:</b> {{ oferta.mes_texto }} · {{ oferta.anio }}
            </div>
          </v-card>

          <div class="d-flex align-center justify-space-between mb-2">
            <div class="text-subtitle-2 purple--text">Programas universidad seleccionados, despues de confirmar el siguiente paso es asignarles la sede correspondiente</div>
            <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
              {{ seleccionados.length }} items
            </v-chip>
          </div>
          <v-data-table
            :headers="headers"
            :items="seleccionados"
            item-key="id"
            dense
            disable-pagination
            hide-default-footer
            class="elevation-1"
            no-data-text="No hay programas seleccionados"
          >
            <template v-slot:item.programaNombre="{ item }">
              <div>
                <div>{{ item.programaNombre }}</div>
                <div class="caption grey--text">{{ item.areaUniversidad ? item.areaUniversidad.nombre : '' }}</div>
              </div>
            </template>
            <template v-slot:item.ceubArchivoId="{ item }">
              <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                {{ item.ceubArchivoId ? 'si' : 'no' }}
              </v-chip>
            </template>
            <template v-slot:item.programas="{ item }">
              <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                {{ item.programas ? item.programas.length : 0 }}
              </v-chip>
            </template>
            <template v-slot:item.estado="{ item }">
              <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                {{ item.estado }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <!-- <div class="text-subtitle-2 purple--text text-right pr-4">Despues de confirmar el siguiente paso es asignarles la sede correspondiente</div> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Revisar</v-btn>
          <v-btn color="teal darken-2" class="white--text" @click="confirmar()">
            <v-icon left small>mdi-content-save</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolvePromise: null,
      oferta: {
        nombre_oferta: '',
        mes_texto: '',
        anio: ''
      },
      seleccionados: [],
      headers: [
        { text: 'Codigo', value: 'codigo' },
        { text: 'Programa Universidad', value: 'programaNombre' },
        { text: 'Sede Universidad', value: 'sedeUniversidad' },
        { text: 'CEUB', value: 'ceubArchivoId' },
        { text: 'Programas ESAM', value: 'programas' },
        { text: 'Estado', value: 'estado' },
      ],
    };
  },
  methods: {
    openmodal(payload) {
      this.oferta = payload.oferta;
      this.seleccionados = payload.seleccionados || [];
      this.dialog = true;
      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    cerrar() {
      if(this.resolvePromise) this.resolvePromise(false);
      this.dialog = false;
    },
    confirmar() {
      if(this.resolvePromise) this.resolvePromise(true);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.mc-card {
  border-radius: 14px;
  overflow: hidden;
}
.mc-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
